import { render, staticRenderFns } from "./B2cAddCouponModal.vue?vue&type=template&id=afcaa2ea"
import script from "./B2cAddCouponModal.vue?vue&type=script&lang=ts"
export * from "./B2cAddCouponModal.vue?vue&type=script&lang=ts"
import style0 from "./B2cAddCouponModal.vue?vue&type=style&index=0&id=afcaa2ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports